import type { TimeBand } from './salesSnapshotTypes';

/** Rangos de franja horaria (mañana/tarde/noche) para un día local; compartido con informes remotos. */
export const getSalesTimeBandWindows = (
  dateIso: string
): { key: TimeBand; label: string; start: string; end: string }[] => {
  const dayStart = new Date(dateIso);
  dayStart.setHours(0, 0, 0, 0);
  const dayEnd = new Date(dateIso);
  dayEnd.setHours(23, 59, 59, 999);

  const morningStart = new Date(dayStart);
  morningStart.setHours(6, 0, 0, 0);
  const morningEnd = new Date(dayStart);
  morningEnd.setHours(11, 59, 59, 999);
  const afternoonStart = new Date(dayStart);
  afternoonStart.setHours(12, 0, 0, 0);
  const afternoonEnd = new Date(dayStart);
  afternoonEnd.setHours(19, 59, 59, 999);
  const nightStart = new Date(dayStart);
  nightStart.setHours(20, 0, 0, 0);
  const nightEnd = new Date(dayEnd);

  return [
    { key: 'morning', label: 'Mañana (6-12h)', start: morningStart.toISOString(), end: morningEnd.toISOString() },
    { key: 'afternoon', label: 'Tarde (12-20h)', start: afternoonStart.toISOString(), end: afternoonEnd.toISOString() },
    { key: 'night', label: 'Noche (20-6h)', start: nightStart.toISOString(), end: nightEnd.toISOString() },
  ];
};
